import React, { useState } from 'react';
import { Route, Switch } from 'react-router-dom';
import Authenticator from './utils/Authenticator';
import FormHero from './components/FormHero';
import ErrorPage from './components/ErrorPage';
import UnAuthFlow from './components/UnAuthFlow';
import { appConstants, langContent } from './utils/appConstants';
import Logout from './components/Logout';
import { Progress } from '@awesomecomponents/mux';
import StepUpHandler from './components/StepUpHandler';
// import queryString from 'querystringify';

import packageJson from '../package.json';
const basePath = packageJson.homepage;

const Routes = ({ isAuthenticated, setIsAuthenticated, oidc }) => {
  const [lang, setLang] = useState(appConstants.MANULIFE_EN_LANG);
  const content = langContent[lang];
  const unProtectedRoutes = [
    <Route key="logout" exact path={`${basePath}/logout`}>
      <Logout langContent={langContent} isPublic={false} />
    </Route>,
    <Route key="publiclogout" exact path={`${basePath}/public/logout`}>
      <Logout langContent={langContent} isPublic={true} />
    </Route>,
    <Route
      key="redirect"
      exact
      path={`${basePath}/redirect`}
      component={() => {
        window.location = appConstants.MANULIFE_URL;
        return <Progress />;
      }}
    />,
    <Route key="unautherror">
      <ErrorPage />
    </Route>,
  ];

  const protectedRoutes = [
    <Route
      key="authflow"
      exact
      path={`${basePath}/:business_unit/:form_name`}
      component={(compProps) => {
        const { business_unit, form_name } = compProps.match.params;
        return (
          <FormHero
            business_unit={business_unit}
            form_name={form_name}
            lang={lang}
            langContent={content}
            isAuthenticated={isAuthenticated}
            setIsAuthenticated={setIsAuthenticated}
          />
        );
      }}
    />,
    <Route key="error">
      <ErrorPage type="error" lang={lang} />
    </Route>,
  ];

  return (
    <Switch>
      <Route
        key="authentication"
        exact
        path={`${basePath}/auth/:transfer_token/:business_unit/:language/:form_name`}
        render={(compProps) => {
          // const transfer_token = queryString.parse(window.location.search).token;
          const { transfer_token, business_unit, language, form_name } = compProps.match.params;
          return (
            <Authenticator
              transfer_token={transfer_token}
              history={compProps.history}
              business_unit={business_unit}
              language={language}
              form_name={form_name}
              setLang={setLang}
              setIsAuthenticated={setIsAuthenticated}
              oidc={oidc}
            />
          );
        }}
      />
      <Route key="error" exact path="/error">
        <ErrorPage type="error" lang={lang} />
      </Route>
      <Route
        key="unauthflow"
        exact
        path={`${basePath}/public/:business_unit/:language/:form_name`}
        component={(compProps) => {
          const { business_unit, language, form_name } = compProps.match.params;
          const { URL_FR_LANG, MANULIFE_EN_LANG, MANULIFE_FR_LANG } = appConstants;
          const langCont = language === URL_FR_LANG ? MANULIFE_FR_LANG : MANULIFE_EN_LANG;
          if (
            (window.location.hostname.toLowerCase() === 'stage.portal.manulife.ca' &&
              business_unit === 'insurance-draft') ||
            (window.location.hostname.toLowerCase() === 'portal.manulife.ca' && business_unit === 'insurance')
          ) {
            return <ErrorPage />;
          }
          return (
            <UnAuthFlow
              business_unit={business_unit}
              form_name={form_name}
              lang={langCont}
              langContent={langContent[langCont]}
            />
          );
        }}
      />
      <Route key="stepup" exact path={`${basePath}/stepup`}>
        <StepUpHandler oidc={oidc} />;
      </Route>
      {isAuthenticated ? protectedRoutes : unProtectedRoutes}
    </Switch>
  );
};

export default Routes;
